exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bg-icon-download[data-v-0f3e80af] {\n  display: grid;\n  place-items: center;\n  cursor: pointer;\n}\n.bg-icon-download .icon-download[data-v-0f3e80af] {\n  width: 28px;\n  height: 28px;\n  color: #27488e;\n}\n.download-informepdf.disabled i[data-v-0f3e80af] {\n  color: #cccccc;\n  cursor: no-drop;\n}\n", ""]);

// exports
